import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css";

import { db } from '@/main'
import helpers from '@/helpers.js'
import { getAuth } from 'firebase/auth'
import { 
  doc,
  setDoc
} from "firebase/firestore";

export default {
  name: 'create-resource',
  components: {
    Multiselect
  },
  props: [],
  data () {
    return {
      newResource: {
        image: null,
        name: "",
        description: "",
        tags: [],
        type: "Desk"
      },
      resourceType: {
        label: this.$t("resource-edit-type-Desk"),
        value: "Desk"
      },
      view: {
        status: "waiting",
        userSelectingImage: false,
        restricted: false,
        error: null
      },
      bulkData: {
        enabled: false,
        count: 10,
        resourceType: "Generic",
        status: null
      },
      tagInput: ""
    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    },
    org () {
      return this.$store.getters.activeOrg
    },
    formDisabled () {
      if(this.newResource.name.length) return false

      return true
    },
    resourceTags () {
      return this.$store.getters.resourcesTags
    },
    resourceTypes () {
      return [
        {
          label: this.$t("resource-edit-type-Desk"),
          value: "Desk"
        },
        {
          label: this.$t("resource-edit-type-Table"),
          value: "Table"
        },
        {
          label: this.$t("resource-edit-type-Room"),
          value: "Room"
        },
        {
          label: this.$t("resource-edit-type-Booth"),
          value: "Booth"
        },
        {
          label: this.$t("resource-edit-type-Parking-Spot"),
          value: "Parking-Spot"
        },
        {
          label: this.$t("resource-edit-type-Custom-1"),
          value: "Custom-1"
        },
        {
          label: this.$t("resource-edit-type-Custom-2"),
          value: "Custom-2"
        }
      ]
    }
  },
  mounted () {
  
    console.log('this.$route:', this.$route);
    
    if('bulk' in this.$route.query){
      // enable bulk mode
      this.bulkData.enabled = true
    }
  },
  methods: {
    submitForm () {
      
      // clean up state
      this.view.status = 'saving'
      this.view.error = null

      this.newResource.type = this.resourceType.value

      if(this.bulkData.enabled) {
        this.bulkCreate()
      } else {
        this.createResource()
      }
    },
    async createResource () {
      console.log("creating resource:", this.newResource)

      let resourceData = { ...this.newResource }
      resourceData.updater = this.user.id

      resourceData.orgLink = this.org.id

      let resourceObj = new helpers.Resource(resourceData);

      try {
        await setDoc(
            doc(
              db, 
              "orgs", 
              this.org.id, 
              "resources", 
              resourceObj.id).withConverter(helpers.resourceConverter), resourceObj, {
                merge: true
              })

        this.$store.dispatch("updateDoc", {
          data: resourceObj,
          action: "add",
          docType: "resources",
        });

        this.$toast.success(`${this.newResource.name} added!`)

        this.$router.push(`/${this.org.name}/resources`)
      } catch (error) {
        console.log('err adding resource:', error)
        this.view.error = error
      }
    },
    async onImageUploadSuccess (res) {
      console.log("image upload success:", res)

      this.newResource.image = res.filePath
    },
    onImageUploadError (err) {
      console.log("err:", err)
      this.$toast.error(`Something went wrong caving your new image`)
    },
    initImageUpload () {
      console.log("init image change")
      this.view.userSelectingImage=true;
      this.$refs.imageUploader.childNodes[0].click()
    },
    async bulkCreate () {

      console.log("bulk creating:", this.bulkData)

      const auth = getAuth();
      const user = auth.currentUser;
      let token = await user.getIdToken(user, true)

      this.newResource.orgLink = this.org.id;

      let resourceObj = new helpers.Resource(this.newResource)
      let processedObj = helpers.resourceConverter.toFirestore(resourceObj)

      let obj = {
        count: parseFloat(this.bulkData.count),
        type: "resource",
        org: this.org.id,
        token: token,
        data: processedObj,
      };

      console.log('obj to post:', obj);

      try {

        let res = await fetch('/api/bulkcreate', {
          method: 'post',
          body: JSON.stringify(obj),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })

        res = await res.json();

        console.log("res:", res);

        if(!res.error){
          this.$toast.success("Bulk create complete");

          // res.data.forEach(doc => {
          //   this.$store.dispatch("updateDoc", {
          //     data: doc,
          //     action: "add",
          //     docType: "resources",
          //   });
          // })

          this.$router.push(`/${this.org.name}/resources`)
        } else {
          throw res.message
        }
      } catch (error) {
        this.view.error = error
        console.log("error:", error)
      }

      this.view.status = "waiting"

    },
    removeTag (tag) {
      console.log('remove tag:', tag)
      let newTags = this.newResource.tags.filter((existingTag)=>{
        return existingTag !== tag 
      })
      console.log('tags now:', newTags)
      this.newResource.tags = newTags
    },
    tagInputChange (e) {

      if(e.inputType !== "insertText"){
        return
      }

      // if it doesn't have data, it was not a keypress, was enter or mouse click
      if(!e.data){
        this.addTag()
      }

      if(this.tagInput.indexOf(",")>0){
        this.addTag()
      }
    },
    addTag () {
      let tags = this.tagInput.split(",")
      tags.forEach(tag => {
        console.log("tag:", tag)
        if(tag.length){
          this.newResource.tags.push(tag.toLowerCase())
        }
      })
      this.tagInput = ""
    },
  }
}
